//"home" | "delayed" | "away" | "earlyPlow" | "latePlow" | "urgent"
export enum LocationActionAnnualStatusEnum {
  home = "home",
  delayed = "delayed",
  away = "away",
  urgent = "urgent",
}

export enum LocationActionOnDemandStatusEnum {
  earlyPlow = "earlyPlow",
  latePlow = "latePlow",
  urgent = "urgent",
}

export const locationActionAnnualStatusEnumValues = Object.values(
  LocationActionAnnualStatusEnum,
);
export const locationActionAnnualStatusEnumLabelMap: Record<
  LocationActionAnnualStatusEnum,
  string
> = {
  [LocationActionAnnualStatusEnum.home]: "Home",
  [LocationActionAnnualStatusEnum.delayed]: "Delay",
  [LocationActionAnnualStatusEnum.away]: "Skip",
  [LocationActionAnnualStatusEnum.urgent]: "Urgent",
};

export const locationActionOnDemandStatusEnumValues = Object.values(
  LocationActionOnDemandStatusEnum,
);
export const locationActionOnDemandStatusEnumLabelMap: Record<
  LocationActionOnDemandStatusEnum,
  string
> = {
  [LocationActionOnDemandStatusEnum.earlyPlow]: "Early Plow",
  [LocationActionOnDemandStatusEnum.latePlow]: "Late Plow",
  [LocationActionOnDemandStatusEnum.urgent]: "Urgent",
};

export const locationActionAnnualSelectOptions =
  locationActionAnnualStatusEnumValues.map((c) => ({
    label: locationActionAnnualStatusEnumLabelMap[c],
    value: c,
  }));

export const locationActionOnDemandSelectOptions =
  locationActionOnDemandStatusEnumValues.map((c) => ({
    label: locationActionOnDemandStatusEnumLabelMap[c],
    value: c,
  }));
